export const SOURCE_METRIC_OPTIONS = [
  { value: 'LOGISTIC_COMMISSION', label: 'auto-adjustment-rules:sourceMetric.LOGISTIC_COMMISSION' },
];

export const SOURCE_METRIC_ALLOWED_FROM_TYPES: Record<string, string[]> = {
  LOGISTIC_COMMISSION: ['DISTRIBUTION_CENTER', 'LOGISTIC', 'WAREHOUSE'],
};

// Source types for which a SPECIFIC supplier scope is configurable. DC is
// excluded (handling is per-suborder, not supplier-attributable). Mirrors the
// backend SUPPLIER_SCOPE_ALLOWED_FROM_TYPES.
export const SUPPLIER_SCOPE_ALLOWED_FROM_TYPES: string[] = ['LOGISTIC', 'WAREHOUSE'];
